import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconNoteAlt.tsx
const OutlinedFilledNote_alt = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M287-290h60l256-256.27L544-607 287-349.73V-290Zm334-274 39-39q7-7 7.5-16t-7.5-16l-29-28q-7-8-15.36-7.5-8.37.5-15.64 7.5l-38 38 59 61ZM189-95q-39.03 0-66.51-27.49Q95-149.97 95-189v-582q0-39.44 27.49-67.22Q149.97-866 189-866h180q11-35 41-57.5t70-22.5q40 0 70 22.5t41 57.5h180q39.44 0 67.22 27.78T866-771v582q0 39.03-27.78 66.51Q810.44-95 771-95H189Zm291-696q17.47 0 29.23-11.77Q521-814.53 521-832t-11.77-29.23Q497.47-873 480-873t-29.23 11.77Q439-849.47 439-832t11.77 29.23Q462.53-791 480-791Z" })
});
const OutlinedNote_alt = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M287-290h60l256-256.27L544-607 287-349.73V-290Zm334-274 39-39q7-7 7.5-16t-7.5-16l-29-28q-7-8-15.36-7.5-8.37.5-15.64 7.5l-38 38 59 61ZM189-95q-38.78 0-66.39-27.61T95-189v-582q0-39.19 27.61-67.09Q150.22-866 189-866h180q11-35 41-57.5t70-22.5q40 0 70 22.5t41 57.5h180q39.19 0 67.09 27.91Q866-810.19 866-771v582q0 38.78-27.91 66.39Q810.19-95 771-95H189Zm0-94h582v-582H189v582Zm291-602q17.47 0 29.23-11.77Q521-814.53 521-832t-11.77-29.23Q497.47-873 480-873t-29.23 11.77Q439-849.47 439-832t11.77 29.23Q462.53-791 480-791ZM189-189v-582 582Z" })
});
const RoundedFilledNote_alt = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-95q-38.98 0-66.49-27.51Q95-150.02 95-189v-582q0-38.97 27.51-66.99Q150.02-866 189-866h180q11-35 41-57.5t70-22.5q40 0 70 22.5t41 57.5h180q38.97 0 66.99 28.01Q866-809.97 866-771v582q0 38.98-28.01 66.49Q809.97-95 771-95H189Zm291-696q17.47 0 29.23-11.77Q521-814.53 521-832t-11.77-29.23Q497.47-873 480-873t-29.23 11.77Q439-849.47 439-832t11.77 29.23Q462.53-791 480-791ZM311-290h16q10 0 18-3t15-10l243-243-59-61-244 244q-7 6.86-10 14.93T287-331v18q0 9 7.1 16t16.9 7Zm310-274 39-39q7-7 7.5-16t-7.5-16l-29-28q-7-8-15.5-7.5T600-663l-38 38 59 61Z" })
});
const RoundedNote_alt = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-95q-38.78 0-66.39-27.61T95-189v-582q0-39.19 27.61-67.09Q150.22-866 189-866h180q11-35 41-57.5t70-22.5q40 0 70 22.5t41 57.5h180q39.19 0 67.09 27.91Q866-810.19 866-771v582q0 38.78-27.91 66.39Q810.19-95 771-95H189Zm0-94h582v-582H189v582Zm291-602q17.47 0 29.23-11.77Q521-814.53 521-832t-11.77-29.23Q497.47-873 480-873t-29.23 11.77Q439-849.47 439-832t11.77 29.23Q462.53-791 480-791ZM189-189v-582 582Zm122-101h16.13q9.82 0 17.85-3 8.02-3 15.02-10l243-242.72L544-607 300-363q-7 7.29-10 15.3-3 8.01-3 16.51v18.69q0 8.5 7.2 15.5t16.8 7Zm310-274 39-39q7-7 7.5-16t-7.5-16l-29-28q-7-8-15.36-7.5-8.37.5-15.64 7.5l-38 38 59 61Z" })
});
const SharpFilledNote_alt = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M287-290h60l256-256.27L544-607 287-349.73V-290Zm334-274 55-55-61-59-53 53 59 61ZM95-95v-771h274q11-35 41-57.5t70-22.5q40 0 70 22.5t41 57.5h275v771H95Zm385-696q17.47 0 29.23-11.77Q521-814.53 521-832t-11.77-29.23Q497.47-873 480-873t-29.23 11.77Q439-849.47 439-832t11.77 29.23Q462.53-791 480-791Z" })
});
const SharpNote_alt = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M287-290h60l256-256.27L544-607 287-349.73V-290Zm334-274 55-55-61-59-53 53 59 61ZM95-95v-771h274q11-35 41-57.5t70-22.5q40 0 70 22.5t41 57.5h275v771H95Zm94-94h582v-582H189v582Zm291-602q17.47 0 29.23-11.77Q521-814.53 521-832t-11.77-29.23Q497.47-873 480-873t-29.23 11.77Q439-849.47 439-832t11.77 29.23Q462.53-791 480-791ZM189-189v-582 582Z" })
});
const componentMap = {
	outlined: OutlinedNote_alt,
	"outlined-fill": OutlinedFilledNote_alt,
	rounded: RoundedNote_alt,
	"rounded-fill": RoundedFilledNote_alt,
	sharp: SharpNote_alt,
	"sharp-fill": SharpFilledNote_alt
};
const IconNoteAlt = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconNoteAlt };